import React from "react";
import classnames from "classnames";
import { parse } from "qs";
import { BaseLayout, Footer } from "components";
import { isIOS } from "utils";
import { linkConfig } from "config";
import styles from "./styles.module.scss";

class Download extends React.PureComponent {
  state = {
    iosUrl: linkConfig.download.ios,
    androidUrl: "",
    loading: false,
    title: "立即下载",
  };
  
  componentDidMount() {
    this.resolveAndroidApkByUtmSource();
  }
  
  resolveAndroidApkByUtmSource = () => {
    const search = window.location.search.slice(1);
    const searchParams = parse(search);
    const { utm_source } = searchParams;
    
    let url = linkConfig.download.android.global || "";

    if (utm_source && utm_source !== "") {
      if (utm_source.toLowerCase().includes("sms")) {
        url = linkConfig.download.android.sms || "";
      } else if (utm_source.toLowerCase().includes("tuijian")) {
        url = linkConfig.download.android.tuijian || "";
      } else if (utm_source.toLowerCase().includes("gw")) {
        url = linkConfig.download.android.global || "";
      }
    }

    this.setState({
      androidUrl: url
    })
  }

  render() {
    const ua = window.navigator.userAgent.toLowerCase();
    const isWeixinBrowser = !!ua.match(/MicroMessenger/i);
    return (
      <BaseLayout>
        <div className={classnames("full-screen", styles.download)}>
          {isWeixinBrowser ? (
            <div
              className={classnames(styles.shadow, {
                [styles.android]: !isIOS(),
              })}
            />
          ) : null}
          <h2>顶尖平台 卓越体验</h2>
          <p className={styles.summary}>操作简单易用，随时随地交易</p>

          <div
            className={styles.animate}
            style={{
              backgroundImage: `url("/download/logo.png")`,
            }}
          />
          <h3>下载 富得贵金属 APP</h3>
          <p className={styles.strength}>
            <span>开放</span>
            <span>创新</span>
            <span>安全</span>
            <span>可信</span>
          </p>
          <div className={styles.download_wrapper}>
            <div className="flex-container flex-center">
              {isIOS() && (
                <div className={styles.ios_down}>
                  <a
                    href={this.state.iosUrl}
                    className={classnames("flex-block active", styles.download_btn_store)}
                  >
                    <span className={styles.icon_ios}></span>
                    <span className={styles.text}>富得贵金属</span>
                    <span className={styles.icon}></span>
                  </a>
                </div>
              )}
              {!isIOS() && (
                <a
                  href={this.state.androidUrl}
                  className={classnames(
                    "flex-block active", styles.download_btn, {
                      [styles.loading]: this.state.loading,
                    })}
                >
                  {this.state.title}
                </a>
              )}
            </div>
          </div>
          <Footer />
        </div>
      </BaseLayout>
    );
  }
}

export default Download;
